// ScrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll

module.exports = function (to, from, savedPosition) {
    if (savedPosition) {
        // savedPosition is only available for popstate navigations.
        return savedPosition;
    } else {
        const position = {};

        // scroll to anchor by returning the selector
        if (to.hash) {
            position.selector = to.hash;

            if (document.querySelector(to.hash)) {
                return position;
            }

            // if the returned position is false or an empty object,
            // will retain current scroll position.
            return false;
        }

        return new Promise(resolve => {
            position.x = 0;
            position.y = 0;

            if (typeof this === 'undefined') {
                resolve(position);
                return;
            }

            // wait for the out transition to complete (if necessary)
            this.app.$root.$once('triggerScroll', () => {
                // if the resolved position is false or an empty object,
                // will retain current scroll position.
                resolve(position);
            });
        });
    }
};
